/**
 * @generated SignedSource<<7641d5807f6249cbcc2a73676e2cef01>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTypeDropdown$data = {
  readonly avatar: {
    readonly large: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly issueTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly avatar: {
          readonly small: string | null | undefined;
        } | null | undefined;
        readonly hierarchy: {
          readonly level: number | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly issueTypeId: string | null | undefined;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef">;
  } | null | undefined;
  readonly key: string;
  readonly name: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentType": "IssueTypeDropdown";
};
export type IssueTypeDropdown$key = {
  readonly " $data"?: IssueTypeDropdown$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypeDropdown">;
};

import issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query_graphql from './issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "issueTypes"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": issueTypeDropdown_InlineIssueCreate_RefetchPaginated_Query_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "IssueTypeDropdown",
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    (v2/*: any*/),
    {
      "concreteType": "JiraAvatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "large"
        }
      ]
    },
    {
      "alias": "issueTypes",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        }
      ],
      "concreteType": "JiraIssueTypeConnection",
      "kind": "LinkedField",
      "name": "__inlineIssueCreate_IssueTable_issueTypes_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "issueTypeId"
                },
                (v2/*: any*/),
                {
                  "concreteType": "JiraAvatar",
                  "kind": "LinkedField",
                  "name": "avatar",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "small"
                    }
                  ]
                },
                {
                  "concreteType": "JiraIssueTypeHierarchyLevel",
                  "kind": "LinkedField",
                  "name": "hierarchy",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "level"
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithIssueTypeConnection_issueTypesFragmentRef"
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "endCursor"
            },
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "97d846c1de1aa164712eb51b2bef4085";

export default node;
